import toast from 'react-hot-toast';

interface FetchOptions extends RequestInit {
  silent?: boolean;
}

export async function api<T = any>(url: string, options: FetchOptions = {}): Promise<T> {
  const { silent, ...fetchOptions } = options;
  try {
    const res = await fetch(url, fetchOptions);
    if (!res.ok) {
      const data = await res.json().catch(() => ({ error: `HTTP ${res.status}` }));
      const message = data.error || `Error ${res.status}`;
      if (!silent) toast.error(message);
      throw new Error(message);
    }
    return res.json();
  } catch (err: any) {
    if (err.message && !err.message.startsWith('HTTP') && !err.message.startsWith('Error ')) {
      if (!silent) toast.error('Network error');
    }
    throw err;
  }
}

export function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function authJsonHeaders(): Record<string, string> {
  return { ...authHeaders(), 'Content-Type': 'application/json' };
}
